import ColorSettingsDialog from './color-settings-dialog';

export default {
  ColorSettingsDialog,
};
